import { Capacitor } from '@capacitor/core';

import { getStore } from '../store';
import {
  ROUTE_MAP,
  ROUTE_ON_THE_WATER_PROMPT,
  ROUTE_WEATHER_MOST_RECENT_POSITION,
} from './route-names';
import { transitionToNextRoute } from './route-navigation';

export const getDefaultStartupRoute = () => {
  const weatherOnStartup =
    getStore().getState().appControls.memberSettings?.weatherConfig
      ?.weatherOnStartup;

  return weatherOnStartup === false
    ? ROUTE_MAP
    : ROUTE_WEATHER_MOST_RECENT_POSITION;
};

export const transitionAfterOnboardingComplete = () => {
  const nextRoute = getDefaultStartupRoute();

  if (Capacitor.isNativePlatform()) {
    transitionToNextRoute(ROUTE_ON_THE_WATER_PROMPT, { nextRoute });
  } else {
    transitionToNextRoute(nextRoute);
  }
};
